import {
  FIELDS_TO_TRANSFORM,
  TYPE_FIELDS_TO_TRANSFORM,
} from "services/sosInventoryService/auditEvent/schema";
import { transformFields } from "services/utility/afterGet";

export function afterGet(record) {
  let newRecord = { ...record };
  newRecord = transformFields(newRecord, FIELDS_TO_TRANSFORM);
  return newRecord;
}

// The structure of the response differs depending on the presence of query parameters:
// If the GET request includes both 'type' and 'id' parameters, it returns a different
// data structure than when those parameters are omitted.
// See https://app.clickup.com/t/868bnjgpx?comment=90110158802753&threadedComment=90110159397986
// TODO: unify with afterGet when https://app.clickup.com/t/868f1g4a8 complete
export function afterGetAuditEventType(record) {
  let newRecord = { ...record };
  newRecord = transformFields(newRecord, TYPE_FIELDS_TO_TRANSFORM);
  return newRecord;
}
